import type { IPaymentMethod } from 'features/payment/types';

import { projectDiagnosticCheckoutPayment } from '../context/projectors';
import { useDiagnosticContributor } from '../context/provider';

interface CheckoutPaymentDiagnosticInput {
  paymentMethods: IPaymentMethod[];
  selectedPaymentMethod?: IPaymentMethod | null;
  loading: boolean;
  hasError: boolean;
  noPaymentMethodsAvailable: boolean;
  selectorVisible: boolean;
  canUseApplePay: boolean;
  canUseGooglePay: boolean;
}

export const useCheckoutPaymentDiagnosticContributor = (
  input: CheckoutPaymentDiagnosticInput
): void => {
  useDiagnosticContributor('checkout-payment', () => ({
    checkoutPayment: projectDiagnosticCheckoutPayment(input),
  }));
};
